
          "use strict";
          module.exports = inquire;
          function inquire(moduleName) {
            return null;
          }
        